<div class="row">
  <div class="col">
    <label class="mb-2 d-block">{{ field.label }}</label>

    @for (option of field.options; track option) {
    <div class="form-check">
      <mat-checkbox
        [checked]="control.value?.includes(option.value)"
        (change)="onCheckboxChange($event, option)"
        class="d-block mb-1"
      >
        {{ option.value }}
      </mat-checkbox>
    </div>
    } @if (field.isRequired && (!control.value || control.value.length === 0)) {
    <mat-error> {{ field.label }} is required </mat-error>
    }
  </div>
</div>
